exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".classFooterComponent---2Z397 {\n  position: fixed;\n  left: 0;\n  bottom: 0;\n  width: 100%;\n  min-height: 80px;\n  padding: 20px;\n  background-color: #adb6bc; }\n\n.buttonContainer---vJE1V {\n  display: -webkit-box;\n  display: -moz-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -moz-align-items: center;\n  align-items: center;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  -moz-justify-content: flex-end;\n  justify-content: flex-end;\n  -webkit-box-flex: 1;\n  -moz-flex: 1;\n  -ms-flex: 1;\n  flex: 1; }\n\n.footerButton---3PbYh,\n.downloadSignInCards---10-GK {\n  margin-left: 10px; }\n\n.iconClassName---3BxFp {\n  height: 40px;\n  width: 1px; }\n", ""]);

// exports
exports.locals = {
	"classFooterComponent": "classFooterComponent---2Z397",
	"buttonContainer": "buttonContainer---vJE1V",
	"footerButton": "footerButton---3PbYh",
	"downloadSignInCards": "downloadSignInCards---10-GK",
	"iconClassName": "iconClassName---3BxFp"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[local]---[hash:base64:5]!./~/postcss-loader/lib!./~/sass-loader!./app/components/class-footer/index.scss
// module id = 1136
// module chunks = 3